import { getUserInfo } from 'services/axios/emp'
import { getEmployeeDocumentObjectUrl } from 'services/axios/media'

const actions = {
  USER_SET_STATE: 'USER_SET_STATE',
  USER_LOGIN: 'USER_SET_STATE',
  USER_REGISTER: 'USER_REGISTER',
  USER_LOAD_CURRENT_ACCOUNT: 'USER_LOAD_CURRENT_ACCOUNT',
  USER_LOGOUT: 'USER_LOGOUT',
  USER_DETAILS: 'USER_DETAILS',
  USER_TOGGLE_LOADING: 'USER_TOGGLE_LOADING',
  USER_PROFILE_IMAGE: 'USER_PROFILE_IMAGE',
}

export const toggleLoading = (value) => {
  return {
    type: actions.USER_TOGGLE_LOADING,
    payload: value,
  }
}

export const getUserDetailedInfo = (userId, force = false) => {
  return async (dispatch, getState) => {
    const { user } = getState()

    if (user.isLoading) {
      return user.userDetailedInfo
    }

    if (!force && user.userDetailedInfo?.userId === userId) {
      return user.userDetailedInfo
    }

    dispatch(toggleLoading(true))
    const response = await getUserInfo({ userId })
    dispatch({ type: actions.USER_DETAILS, payload: response?.data?.data })
    dispatch(toggleLoading(false))
    return response?.data?.data
  }
}

export const getUserProfileImage = (imageId, force = false) => {
  return async (dispatch, getState) => {
    const { user } = getState()

    if (!imageId) {
      if (user.userProfileImageUrl) {
        URL.revokeObjectURL(user.userProfileImageUrl)
      }
      dispatch({ type: actions.USER_PROFILE_IMAGE, payload: { id: null, url: null } })
      return null
    }

    if (!force && user.userProfileImageId === imageId && user.userProfileImageUrl) {
      return user.userProfileImageUrl
    }

    try {
      const objectUrl = await getEmployeeDocumentObjectUrl(imageId)
      if (user.userProfileImageUrl) {
        URL.revokeObjectURL(user.userProfileImageUrl)
      }
      dispatch({ type: actions.USER_PROFILE_IMAGE, payload: { id: imageId, url: objectUrl } })
      return objectUrl
    } catch (error) {
      console.error('Error fetching profile image:', error)
      dispatch({ type: actions.USER_PROFILE_IMAGE, payload: { id: null, url: null } })
      return null
    }
  }
}

export default actions
